/**
 * @Author     : zhupengbo_LS
 * @Date       : 2021/3/18 15:11
 * @Copyright  : Copyright (c) 2021, JOMOO
 * @Version    : v1.0
 * @Description: 搜索表单
 */
const searchMixin = {
  watch: {
    /**
     * 当搜索表单改变时，发送emit事件
     * */
    form: {
      immediate: true,
      deep: true,
      handler(nVal) {
        this.$emit('update:queryData', nVal)
      }
    }
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.form.currentPage = 1
      this.$emit('query', this.form)
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      setTimeout(() => {
        this.handleQuery()
      })
    },
    /**
     * 验证表单
     * @return Boolean
     * */
    validateForm() {
      let result = true
      this.$refs.form.validate(valid => {
        if (!valid) {
          result = valid
        }
      })
      return result
    }
  }
}

export default searchMixin
